module.exports = "./assets/assets/资料交接.75f11bd3.docx";